import { attr, Model } from 'redux-orm';
import { createAction, createLoadConst } from '../util';

export default class AutopayAudit extends Model {
  static get modelName() {
    return 'AutopayAudit';
  }

  static reducer({ type, data }, AutopayAudit) {
    if (type === LOAD.SUCCESS) {
      AutopayAudit.delete();

      if (data.response) {
        data.response.forEach((r) => AutopayAudit.upsert(r));
      }
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */
  static get fields() {
    return {
      autopayId: attr(),
      byAdminUserId: attr(),
      bySystemUser: attr(),
      byUserId: attr(),
      changelog: attr(),
      id: attr(),
      logAt: attr(),
      logId: attr(),
      logOp: attr(),
      status: attr(),
      time: attr(), // derived
      title: attr(), // derived
    };
  }
}

export const LOAD = createLoadConst(AutopayAudit.modelName);

export const load = createAction(LOAD);
